import messages from '../complaints-progress-bar/complaints-progress-bar-lang.json';

const lang = document.documentElement.lang || 'hu';

export const ROUTE_NAMES = {
	PROBLEM: messages[lang].routes.problem,
	PERSONAL: messages[lang].routes.personal,
	SUMMARY: messages[lang].routes.summary
};

export const PAGES = [
	{
		text: messages[lang].texts.problem,
		link: ROUTE_NAMES.PROBLEM
	},
	{
		text: messages[lang].texts.personal,
		link: ROUTE_NAMES.PERSONAL
	},
	{
		text: messages[lang].texts.summary,
		link: ROUTE_NAMES.SUMMARY
	}
];

export const ERROR_CLASS = '.has-error';
export const SCROLL_TO_OFFSET = -40;
